import { createGlobalStyle } from "styled-components";
import inter from "../assets/fonts/Inter.ttf";
import 'swiper/css';

export const GlobalStyle = createGlobalStyle`
    @font-face {
    font-family: 'Inter';
    src: url(${inter}) format('truetype-variations');
    font-weight: 100 900;
    font-style: normal;
    font-display: swap;
  }

  html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    background-color: ${({ theme }) => theme.palette.background};
    font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-synthesis: none;
  }

  #root {
    position: relative;
    z-index: 1;
  }

  #root, main {
    overflow-x: hidden;
  }

  img {
    content-visibility: auto;
    contain: layout paint size;
    aspect-ratio: 1 / 1;
  }

  .body-lock {
    position: fixed;
    overflow: hidden;
    width: 100%;
  }

  .swiper {
    width: 100%;
    min-height: 100px;
  }

  .swiper-slide {
    width: clamp(180px, 40vw, 250px) !important;
    display: flex;
    justify-content: center;
  }

  .swiper-pagination {
    bottom: -2rem !important;
  }

  .swiper-pagination-bullet {
    width: 10px !important;
    height: 10px !important;
    border-radius: 50% !important;
    background: ${({ theme }) => theme.palette.primary.medium} !important;
    opacity: .5 !important;
    transition: width .2s, height .2s, opacity .2s, background-color .2s !important;
  }

  .swiper-pagination-bullet-active {
    width: 18px !important;
    height: 6px !important;
    border-radius: 9999px !important;
    background: ${({ theme }) => theme.palette.primary.light} !important;
    opacity: 1 !important;
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.palette.primary.medium} transparent;
  }

  *::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.palette.primary.medium};
    border-radius: 3px;
  }

  *::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.palette.primary.light};
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }
`;
